module.exports = __webpack_public_path__ + "static/media/user.43327d3c.png";